import React, { Component, createRef } from "react"
import PropTypes from "prop-types"

import moment from "moment"
import Avatar from "react-avatar"

import Constants from "./../../../../Phi/Constants"

import FilterDropdown from "./FilterDropdown"

import HSGModalComponent from "../../../HSGModalComponent/HSGModalComponent"
import Validator from "../../../../Components/FormComponent/Validator"

const PROFILE_FORM = [
    {
        key: "hsg-user-name",
        type: "text",
        label: "Name",
        placeholder: "Name",
        value: "inName",
    },
    {
        key: "hsg-user-email",
        type: "text",
        label: "Email",
        placeholder: "Email",
        value: "inEmail",
    },
]

const USER_FORM_PASSWORD = [
    {
        key: "hsg-user-password",
        type: "password",
        label: "Password",
        placeholder: "Password",
        value: "inPassword",
        error: "errorInPassword",
    },
    {
        key: "hsg-user-conform-password",
        type: "password",
        label: "Confirm Password",
        placeholder: "Confirm Password",
        value: "inConfirmPassword",
        error: "errorInConfirmPassword",
    },
]

const STRING_BUTTON_UPDATE_PROFILE = "UPDATE PROFILE"
const STRING_BUTTON_UPDATE_LOCATION = "UPDATE LOCATION"
const STRING_BUTTON_CHANGE_PASSWORD = "CHANGE PASSWORD"
const STRING_BUTTON_COPY_LINK = "COPY LINK"

const STRING_HEAD_PROFILE = "Profile"
const STRING_HEAD_CREDENTIALS = "Change Password"
const STRING_HEAD_VISITOR_LINK = "Visitor's Link"

const STRING_SIGN_UP_FORM_RESPONSE_EMAIL_TAKEN = "Email already exists in our system"

const TYPE_UPLOAD_SCREENSHOT = ["image/jpeg", "image/jpg", "image/png", "image/svg", "image/gif", "image/bmp"]

const TYPE_UPLOAD_SCREENSHOT_ALLOWED = ".jpeg, .jpg, .png, .svg, .gif, .bmp"
const ERROR_INCORRECT_IMAGE_TYPE = "*only accept jpg/png/jpeg/bmp/gif/svg format"

export default class Profile extends Component {
    constructor(props) {
        super(props)

        this.state = {
            visitorsLink: null,
            selectedState:Boolean(JSON.parse(sessionStorage.getItem('custom')).json_value.active_location)? JSON.parse(sessionStorage.getItem('custom')).json_value.active_location.state : '',
            selectedDistrict:Boolean( JSON.parse(sessionStorage.getItem('custom')).json_value.active_location)?  JSON.parse(sessionStorage.getItem('custom')).json_value.active_location.district : '',
            availableDistrict:[]
        }

        this.refProfileUpload = React.createRef()
    }
    
    parseUser(user) {
        let emailChangeId = user.data && user.data.email && user.data.email.id ? user.data.email.id : null
        let proPic = Constants.formatProfilePicURL(user.profilePic)
        this.setState({
            inName: user.fullName,
            inEmail: user.inEmail,

            profilePic: user.profilePic ? proPic : '',

            inUserId: user.userId,

            inDefaultEmail: user.inEmail,
            inDefaultName: user.fullName,
            inDefaultProfilePic: user.profilePic ? proPic : '',

            emailChangeId: emailChangeId,
        })
    }
    
    checkUserStoredState = () => {
        let userStateAvailabe = Boolean(JSON.parse(sessionStorage.getItem('custom')).json_value.active_location) ? Boolean(JSON.parse(sessionStorage.getItem('custom')).json_value.active_location.state) : false;
        return userStateAvailabe;
    }

    checkUserStoredDistrict = () => {
        let userDistrictAvailabe = Boolean(JSON.parse(sessionStorage.getItem('custom')).json_value.active_location) ? Boolean(JSON.parse(sessionStorage.getItem('custom')).json_value.active_location.district): false;
        return userDistrictAvailabe;
    }

    getStateIndex = (state) => {
        let selectedStateIndex;
        selectedStateIndex = Object.keys(Constants.stateCodeMap).indexOf(state);
        return selectedStateIndex + 1;
    }

    getDistrictIndex = (city) => {
        let selectedDistricyIndex;
        selectedDistricyIndex = Object.keys(this.state.availableDistrict).indexOf(city);
        return selectedDistricyIndex + 1;
    }

    componentWillMount() {
        this.parseUser(this.props.user);

        // let selectedOptionIndex;
        // // let districts = this.props.totalCovidData[Constants.stateCodeMap[this.state.selectedState].toUpperCase()].districts;
        // if(Boolean(sessionStorage.getItem('custom'))){
        //     selectedOptionIndex = Object.keys(Constants.stateCodeMap).indexOf(JSON.parse(sessionStorage.getItem('custom')).json_value.active_location.state)
        //     var stateElement = document.getElementsByClassName('select-state');
        //             setTimeout(() => {
        //                 stateElement[0].options[selectedOptionIndex + 1].selected = true;
        //             }, 100);
        //     // console.log(stateIndex)
        // }

        if(this.props.modalTypeHandler !== 'update profile') {
            if(this.checkUserStoredState()){
                let storedState = JSON.parse(sessionStorage.getItem('custom')).json_value.active_location.state.toLowerCase();
                var stateElement = document.getElementsByClassName('select-state');
                let stateIndex = this.getStateIndex(storedState);
                setTimeout(() => {
                    stateElement[0].options[stateIndex].selected = true;
                }, 100);
                this.storeDistricts(storedState);

                if(this.checkUserStoredDistrict()){
                    let storedDistrict = JSON.parse(sessionStorage.getItem('custom')).json_value.active_location.district;
                    var cityElement = document.getElementsByClassName('select-city');
                    let cityIndex;
                    setTimeout(() => {
                         cityIndex = this.getDistrictIndex(storedDistrict)
                        // this.storeDistricts();
                        cityElement[0].options[cityIndex].selected = true;
                    }, 100);
                }
                
            }
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.state.inUserId !== this.props.user.userId || this.state.inName !== this.props.user.fullName) {
            this.parseUser(newProps.user)
        }

        if (
            !newProps.emailAvailable &&
            newProps.emailVerified &&
            this.props.checkValidationResponseType !== newProps.checkValidationResponseType &&
            !this.state.errorinEmail
        ) {
            this.setState({ errorinEmail: STRING_SIGN_UP_FORM_RESPONSE_EMAIL_TAKEN })
        }
    }

    // componentWillUpdate(oldProps, oldState) {
    //     if (this.state.inUserId !== this.props.user.userId || this.state.inName !== this.props.user.fullName) {
    //         this.parseUser(this.props.user)
    //     }
    // }

    profileFormSelectField = (index, key, type, elementKey, label, options, onChange, selected) => {
        return (
            <div className={`hsg-profile-modal-dropdown-root`} key={index}>
                <FilterDropdown isEnabled dropDownId="hsg-covid-dashboard-filter-user" label={selected || label}>
                    {options &&
                        options.map((element, index) => (
                            <div key={index} className="hsg-dashboard-dropdown-menu-option" onClick={() => onChange(element, type)}>
                                <span className="hsg-header-dropdown-text">{element[elementKey]}</span>
                            </div>
                        ))}
                </FilterDropdown>
            </div>
        )
    }

    profileFormInputField = (index, key, type, label, placeholder, value, onChange, error, show, icon) =>
        !show ? null : (
            <div key={index}>
                <div className="hsg-profile-modal-form-group">
                    <label className="hsg-profile-modal-form-label" htmlFor={key}>
                        {label}
                    </label>
                    {/* {this.state[error] ? (
                    <i className="fa fa-info-circle hsg-auth-content-sign-up-form-error-icon" aria-hidden="true" />
                ) : null} */}
                    <input
                        name={key}
                        className={`hsg-profile-modal-form-input ${this.state[error] ? "hsg-profile-modal-form-input-error" : ""}`}
                        // data-tip="" data-for={`${key}-tooltip`}
                        id={key}
                        placeholder={placeholder}
                        type={type}
                        value={value || ""}
                        autoComplete="disabled"
                        disabled={!onChange}
                        onChange={(e) => (onChange ? onChange(e.target.value, value, error) : null)}
                    />
                    {icon ? icon : null}
                    {error ? <span className="hsg-profile-modal-form-error col-xs-12 padding-0">{error}</span> : null}
                </div>
                {/* <ReactTooltip
                className="hsg-auth-content-sign-up-form-error-tooltip"
                id={`${key}-tooltip`}
                type="error"
                effect="solid"
            >
                {this.state[error]}
            </ReactTooltip> */}
            </div>
        )

    profileFormAddEmail = (value) => {
        let possibleError = Validator.requiredWithCustomMessage(value, "Email Address can not be black") || Validator.checkEmail(value)

        this.setState({
            // inEmail: value,
            errorinEmail: possibleError,
        })

        if (value && !possibleError && value !== this.state.inDefaultEmail) {
            this.props.checkEmailAvailability(value)
            this.props.changeValidationResponseType("")
        }
    }

    onFileUpload = (files) => {
        let file = files.target.files[0] || {}
        let type = file.type

        if (TYPE_UPLOAD_SCREENSHOT.includes(type)) {
            // let fileReader = new FileReader()

            // fileReader.onloadend = (e) => {
            //     this.setState({updatedProfilePic: e.target.result})
            // }

            // fileReader.readAsText(file)

            this.setState({
                profilePic: (window.URL ? window.URL : window.webkitURL).createObjectURL(file),
                profilePicObj: file,
                profilePicName: file.name,
                errorNoImageUploaded: false,
            })
        } else {
            this.setState({
                profilePic: null,
                profilePicObj: null,
                profilePicName: null,
                errorNoImageUploaded: ERROR_INCORRECT_IMAGE_TYPE,
            })

            Constants.showToaster("File not supported, please select another one.", "INFO", 6000)
        }
    }

    profileImage = () => {

        // let possiblePic, possibleStage

        // possiblePic = this.state.profilePic && this.state.profilePic.split ? this.state.profilePic.split('/') : []
        // possibleStage = this.state.profilePic && this.state.profilePic.split ? this.state.profilePic.split('blob') : []
        
        // let base = possiblePic[possiblePic.length - 2]
        // let name = possiblePic[possiblePic.length - 1]

        // base = base === 'user-profile-pictures' ? 'user-profile-pictures' : ''

        return (
            <div className="margin-top-20 center icon-profile-image">
                {/* <input 
                    type="file" id="file" ref={this.refProfileUpload} style={{display: "none"}} onClick={(e)=>{
                        let x = e
                    }}
                ></input>
                <i class="fa fa-pencil-square-o" onClick={()=>{
                    this.refProfileUpload.current.click()
                }} aria-hidden="true"></i> */}
                <Avatar
                    round={true}
                    size={150}
                    name={this.state.inDefaultName}
                    src={this.state.profilePic}
                />
                <label className="hsg-user-profile-picture">
                    <input type="file" onChange={(file) => this.onFileUpload(file)} accept={TYPE_UPLOAD_SCREENSHOT_ALLOWED} />
                    <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                </label>
            </div>
        )
    }

    profileForm = () => (
        <div className="margin-top-20">
            <div className="hsg-profile-modal-form-sub-head">{STRING_HEAD_PROFILE}</div>
            <div>
                {PROFILE_FORM.map((element, index) =>
                    this.profileFormInputField(
                        index,
                        element.key,
                        element.type,
                        element.label,
                        element.placeholder,
                        this.state[element.value] || "",
                        (e, value, error) => {
                            if (element.value === "inName") {
                                this.setState({
                                    [element.value]: e,
                                    ["error" + element.value]: Validator.requiredWithCustomMessage(e, "Name cannot be black") || Validator.checkPersonName(e),
                                })
                            } else if (element.value === "inEmail") {
                                this.setState({ [element.value]: e })
                                this.profileFormAddEmail(e)
                            }
                        },
                        this.state["error" + element.value],
                        true
                    )
                )}
            </div>
        </div>
    )

    userFormPassword = (validationMap) => {
        return (
            <div className="">
                {/* <div className="hsg-profile-modal-form-sub-head">{STRING_HEAD_CREDENTIALS}</div> */}
                <div>
                    {USER_FORM_PASSWORD.map((element, index) =>
                        this.profileFormInputField(
                            index,
                            element.key,
                            !this.state["icon" + element.value] ? element.type : "text",
                            element.label,
                            element.placeholder,
                            this.state[element.value],
                            (e) =>
                                this.setState({
                                    [element.value]: e,
                                    [element.error]: validationMap[element.key](e, index === 1 ? this.state[USER_FORM_PASSWORD[0].value] : null),
                                }),
                            this.state[element.error],
                            true,
                            this.state["icon" + element.value] ? (
                                <i
                                    className="fa fa-eye-slash"
                                    style={{ position: "absolute", marginTop: 12, right: 24, fontSize: 18, cursor: "pointer" }}
                                    onClick={() => this.setState((pState) => ({ ["icon" + element.value]: !pState["icon" + element.value] }))}
                                    aria-hidden="true"
                                ></i>
                            ) : (
                                <i
                                    className="fa fa-eye"
                                    style={{ position: "absolute", marginTop: 12, right: 24, fontSize: 18, cursor: "pointer" }}
                                    onClick={() => this.setState((pState) => ({ ["icon" + element.value]: !pState["icon" + element.value] }))}
                                    aria-hidden="true"
                                ></i>
                            )
                        )
                    )}
                </div>
            </div>
        )
    }

    userForm = () => {
        let validationMap = {
            [USER_FORM_PASSWORD[0].key]: (value) =>
                Validator.required(value) || Validator.minValue(4, "Password Must be more then 4 characters")((value && value.length) || 0),
            [USER_FORM_PASSWORD[1].key]: (value, match) => (value === match ? undefined : "Password do not match"),
        }

        return (
            <div className="">
                <div>{this.userFormPassword(validationMap)}</div>
                <div className="margin-top-10 center">
                    {/* <button
                        className="hsg-btn hsg-profile-modal-button-change-password"
                        onClick={() => {
                            let {inPassword, inConfirmPassword, errorInPassword, errorInConfirmPassword} = this.state;
                            if (inPassword && inConfirmPassword && !errorInPassword && !errorInConfirmPassword) {
                                this.props.changePassword(this.state.inPassword);
                                this.setState({inPassword: null, inConfirmPassword: null});
                            } else {
                                this.setState({
                                    [USER_FORM_PASSWORD[0].error]: validationMap[USER_FORM_PASSWORD[0].key](inPassword),
                                    [USER_FORM_PASSWORD[1].error]: validationMap[USER_FORM_PASSWORD[1].key](inConfirmPassword, inPassword),
                                });
                            }
                        }}
                    >
                        {STRING_BUTTON_CHANGE_PASSWORD}
                    </button> */}
                </div>
            </div>
        )
    }

    updateOrganization() {
        const { inStateID, inCityID, id, defaultInCity, defaultInState, inCity, inState } = this.state.organization

        if (inStateID && inCityID && (inState !== defaultInState || inCity !== defaultInCity)) {
            if (id) {
                this.props.updateOrganization(id, {
                    inOrganizationDistrict: inCityID,
                    inOrganizationState: inStateID,
                })
                this.props.onClose()
            } else {
                Constants.showToaster("Oops! Something went terribly wrong.", "ERROR")
            }
        } else {
            Constants.showToaster("Please check the profile form", "WARNING")
        }
    }

    getState = (e) => {
        e.persist();
        this.setState({
            selectedState: e.target.value.split('&&')[0]
        })
        sessionStorage.setItem('selected-state',e.target.value);
       
        if(Boolean(sessionStorage.getItem('selected-city'))){
            sessionStorage.removeItem('selected-city')
            this.setState({
                selectedDistrict: null,
            })
        }
        debugger;   
        if(this.state.availableDistrict.length !== 0 && Object.keys(this.state.availableDistrict)[0] !== 'Unknown') {
            var cityElement = document.getElementsByClassName('select-city');
            cityElement[0].selectedIndex = 0;
        }
        this.setState({
            selectedDistrict: null,
        })
            setTimeout(() => {
               this.storeDistricts(e.target.value.split('&&')[0]);
            }, 100);
    }

    storeDistricts = (state) => {
      if(state !== 'india'){
        let districts = this.props.totalCovidData[Constants.stateCodeMap[state.toLowerCase()].toUpperCase()].districts;
        this.setState({
            availableDistrict: districts
        })
     
        if(Object.keys(districts)[0] === 'Unknown') {
            sessionStorage.setItem('selected-city','');

        }
      }
      else {
          this.setState({
              availableDistrict: ''
          })
      }
    }

    getDistrictData = (e) => {
        e.persist();
        this.setState({
            selectedDistrict: e.target.value.split('&&')[0]
        })
        sessionStorage.setItem('selected-city',e.target.value);


    }

    changeLocation = () => {
        return (
           <React.Fragment>
               
               <div className = "change__location__container">
                <div className="select__container">
                    <div>
                   <p className = "location__text">Choose a location to see area specific   Covid-19 updates.</p>

                        <label className="hsg-profile-modal-form-label">Select State</label>
                        <select  className = "select-custom select-state" onChange = {(e) => this.getState(e)}>
                            <option selected value = 'india' >India</option>
                            {
                                Object.keys(Constants.stateCodeMap).map((state,index) => {
                                return (
                                        <option key = {index} value = {state+'&&'+index} >
                                            {state.charAt(0).toUpperCase() + state.slice(1)}
                                        </option>
                                    )
                                })
                            }    
                        </select>   
                    </div>
                <div>
              {
                this.state.availableDistrict.length !== 0 && Object.keys(this.state.availableDistrict)[0] !== 'Unknown' && <div>
                    <div className="select__container">
                    <label className="hsg-profile-modal-form-label" >Select City</label>

                            <select  className = "select-custom select-city" onChange = {(e) => this.getDistrictData(e)}>
                                <option selected value = '' >Select District</option>

                                {
                                    Object.keys(this.state.availableDistrict).map((city,index) => {
                                    return <option key = {index} value = {city+'&&'+index}>{city}</option>
                                    })
                                }
                            </select>   
                    </div>
                </div>
                }
              </div>
            </div>
               </div>

           </React.Fragment>
        )
    }

    getStateCode = (state) => {
        let code;
        code = Constants.stateCodeMap[state.toLowerCase()];
        return code;
    }

    updateUsers() {
        if(this.props.modalTypeHandler === 'update profile') {
            let {
                inName,
                inEmail,
                inPassword,
                inConfirmPassword,
                inDefaultEmail,
                inDefaultName,
                inUserId,
                emailChangeId,
                profilePicObj,
                profilePic,
                inDefaultProfilePic,
            } = this.state
    
            inName = inName && inName.trim ? inName.trim() : inName
            inEmail = inEmail && inEmail.trim ? inEmail.trim() : inEmail
    
            const { errorinName, errorinEmail, errorinPassword, errorinConformPassword } = this.state
    
            const updatePass = inPassword && inConfirmPassword && !errorinPassword && !errorinConformPassword ? true : false
            const updatePro = inName && inEmail && !errorinName && !errorinEmail && (inDefaultName !== inName || inDefaultEmail !== inEmail) ? true : false
            const updatePic = profilePic !== inDefaultProfilePic && profilePicObj ? true : false
    
            let finalObj = null
    
            if (updatePass || updatePro || updatePic) {
                finalObj = {
                    userId: inUserId,
                    emailChangeId: emailChangeId,
    
                    inPassword: updatePass ? inPassword : null,
                    fullName: updatePro ? inName : null,
                    inEmail: updatePro ? inEmail : null,
                    profilePic: updatePic ? profilePic : null,
                    profilePicObj: updatePic ? profilePicObj : null,
                }
            }
    
            if (finalObj) {
                this.props.updateUserProfile(finalObj)
                this.props.onClose()
            } else {
                Constants.showToaster("Please check the profile form.", "WARNING")
            }
        }
        else {
            let payload;
            if(this.state.selectedState === 'india') {
                payload = {
                    country: "India",
                    state: null,
                    district: null,
                    user_id:JSON.parse(sessionStorage.getItem('profile')).user_id,
                    stateCode:null
                }
                this.props.getCovidStats(null,null);
                this.props.postUserLocation(payload)
                this.props.onClose()

            }
            else {
                if(Boolean(this.state.selectedState) && Boolean(this.state.selectedDistrict)) {
                    payload = {
                        country: "India",
                        state: Constants.titleCase(this.state.selectedState),
                        district: Constants.titleCase(this.state.selectedDistrict),
                        user_id:JSON.parse(sessionStorage.getItem('profile')).user_id,
                        stateCode:  this.getStateCode(this.state.selectedState)

                    }
                    this.props.getCovidStats(this.state.selectedState,this.state.selectedDistrict)
                    this.props.postUserLocation(payload)
                    this.props.onClose()
                }
                if(Boolean(this.state.selectedState) && !Boolean(this.state.selectedDistrict)) {
                    payload = {
                        country: "India",
                        state: Constants.titleCase(this.state.selectedState),
                        district:null,
                        user_id:JSON.parse(sessionStorage.getItem('profile')).user_id,
                        stateCode:  this.getStateCode(this.state.selectedState)
                    }
                    this.props.getCovidStats(this.state.selectedState,null)
                    this.props.postUserLocation(payload)
                    this.props.getUser();
                    this.props.onClose()
                }
                // if(!Boolean(this.state.selectedState) && Boolean(this.state.selectedDistrict)) {
                //     payload = {
                //         country: "India",
                //         state: null,
                //         city: this.state.selectedDistrict,
                //     }
                //     this.props.getCovidStats(null,this.state.selectedDistrict)
                //     this.props.postUserLocation(null,this.state.selectedDistrict)

                //     this.props.onClose()
                // }
                // // else if ()
            }
        }
    }

    onClose() {
        this.setState({
            inName: null,
            inEmail: null,

            inDefaultEmail: null,
            inDefaultName: null,

            inPassword: null,
            inConfirmPassword: null,

            errorinName: null,
            errorinEmail: null,
            errorinPassword: null,
            errorinConfirmPassword: null,

            inUserId: null,
        })
        this.props.onClose()
    }

    render() {
        const { show, onClose } = this.props

        return (
            <HSGModalComponent
                show={show || false}
                onClose={() => this.onClose()}
                onHide={() => this.onClose()}
                header={""}
                bsSize={null}
                body={
                    <div className="container-fluid">
                        <div className="col-xs-12 hsg-profile-modal-root">
                           {
                               this.props.modalTypeHandler === 'update profile' ? (
                                   <React.Fragment>
                                        <div className="col-xs-12 col-sm-12">{this.profileImage()}</div>
                                        <div className="col-xs-12 col-sm-12">{this.profileForm()}</div>
                                        <div className="col-xs-12 col-sm-12">{this.userForm()}</div>
                                        {/* {this.profileFormSelectField()} */}
                                   </React.Fragment>
                               )
                               :
                               (
                                   <React.Fragment>
                                       <div className = "col-xs-12 col-sm-12">
                                           <h1 className = "location__heading">Choose Location</h1>
                                            {this.changeLocation()}
                                       </div>
                                   </React.Fragment>
                               )
                           }

                            <div className="col-xs-12 col-sm-12 margin-top-20 center">
                                <button className="hsg-btn hsg-profile-modal-button-change-password" onClick={() => this.updateUsers()}>
                                    {
                                        this.props.modalTypeHandler === 'update profile' ? STRING_BUTTON_UPDATE_PROFILE : STRING_BUTTON_UPDATE_LOCATION
                                    }
                                    
                                </button>
                            </div>
                        </div>
                    </div>
                }
            />
        )
    }
}
